/**
 * Конфигурация валюты для всего приложения
 * Измените CURRENCY_SYMBOL чтобы поменять символ валюты во всём приложении
 */
import { TbCurrencyLari } from "react-icons/tb";

// Символ валюты (например: '₽', '₴', '€', '$', '£', '₾')
export const CURRENCY_SYMBOL = "₾";

// Иконка валюты (из react-icons)
// Доступные иконки: TbCurrencyLari, TbCurrencyRubel, TbCurrencyEuro, TbCurrencyDollar и др.
export const CurrencyIcon = TbCurrencyLari;

// Форматирование цены с символом валюты
export const formatPrice = (price: number, decimals: number = 2): string => {
  return `${price.toFixed(decimals)} ${CURRENCY_SYMBOL}`;
};
